import styled, { ThemeProvider } from 'styled-components';
// Typed this way to get around poor type inference
// For key values @see `IconSize` in ./types
// exported for tests and storybook
export var iconSizeToPixelValue = {
  xsmall: 16,
  small: 24,
  medium: 32,
  large: 48
}; // exported for testings

export var iconSizeToRemValue = {
  xsmall: 1,
  small: 1.5,
  medium: 2,
  large: 3
};
export var featureIllustrationIconSizeToPixelValue = {
  small: 32,
  medium: 72,
  large: 160
};
export var featureIllustrationIconSizeToRemValue = function featureIllustrationIconSizeToRemValue(size) {
  return featureIllustrationIconSizeToPixelValue[size] / 16;
};
export var sceneIllustrationIconSizeToPixelValue = {
  small: 264,
  medium: 376,
  large: 544
};
export var sceneIllustrationIconSizeToRemValue = function sceneIllustrationIconSizeToRemValue(size) {
  return sceneIllustrationIconSizeToPixelValue[size] / 16;
};
export var SVGThemeProvider = ThemeProvider;
export var SVGStyled = styled;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/svg-icon/dist/esm/shared.js
// module id = 328
// module chunks = 11